import "../../styles/loader.css";

export const LoadingIndicator = () => {
    return (
        <div className="indicator-container">
            <img src="/svgs/loader.svg" width={50} height={50} className="loader" alt="" />
        </div>
    )
}

export const SmallLoader = ({ref}) => {
    return (
        <div className="fitting-container" ref={ref}>
            <img src="/svgs/loader.svg" width={50} height={50} className="loader" alt="" />
        </div>
    )
}